import { useQuery } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { fetchStateData } from "../Services/fetchStateData";

export default function useStateData({ countryId }) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: ["serviceOperation", "stateData", { countryId }],
    queryFn: () => fetchStateData({ accessToken, countryId }),
    staleTime: Infinity,
    enabled: !!countryId && !!accessToken,
    retry: false,
  });
}
